module.exports = __webpack_public_path__ + "static/cai_software_datamanagementtools-270619e4bf560f7a3d92568ae8397c3a.png";